import React, { useState, useEffect } from "react";
import HeaderNonSrp from "../header/headerNonSrp";
import SubHeader from "../header/subHeader";
import Footer from "../footer/footer";
import AccountLoader from "../manageAccount/accountLoader";
import { getparamsString, GetRequest } from "../common/helper";
import { apiUrl } from "../common/constants";

import {
  t,
  BUS_TIME_TABLE_RESULT,
  FROM,
  TO,
  SERVICE_NO,
  SERVICE_CLASS,
  VIA_PLACES,
  TIMINGS,
  TIME_TABLE_NOT_PRESENT,
} from "../../translations/BusTimeTable";

const Result = () => {
  const params = new URLSearchParams(window.location.search);
  const frStateId = params.get("frStateId");
  const toStateId = params.get("toStateId");
  const frCityId = params.get("frCityId");
  const toCityId = params.get("toCityId");

  const [loader, setLoader] = useState(false);
  const [timeTableDate, setTimeTableData] = useState(false);

  useEffect(() => {
    if (frStateId > 0 && toStateId > 0) {
      setLoader(true);
      const data = {
        frStateId: frStateId,
        toStateId: toStateId,
        frCityId: frCityId,
        toCityId: toCityId,
      };

      const url = apiUrl.getTimeTable + "?" + getparamsString(data);
      GetRequest(url)
        .then((res) => {
          setLoader(false);
          if (res) {
            if (res.TimeTableResult) {
              setTimeTableData(res.TimeTableResult);
            }
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    }
  }, []);

  return (
    <div className="timetable--result--wrapper">
      {loader && <AccountLoader />}
      <HeaderNonSrp />
      <SubHeader />
      <div className="timetable--result--wrap">
        <div className="timetable--result--heading">
          {t(BUS_TIME_TABLE_RESULT)}
        </div>
        <div className="timetable--result-container">
          <div className="timetable--result-header">
            <div className="header--cols" style={{ width: "18%" }}>
              {t(FROM)}
            </div>
            <div className="header--cols" style={{ width: "18%" }}>
              {t(TO)}
            </div>
            <div className="header--cols" style={{ width: "19%" }}>
              {t(SERVICE_CLASS)}
            </div>
            <div className="header--cols" style={{ width: "19%" }}>
              {t(VIA_PLACES)}
            </div>
            <div className="header--cols" style={{ width: "15%" }}>
              {t(SERVICE_NO)}
            </div>
            <div className="header--cols" style={{ width: "11%" }}>
              {t(TIMINGS)}
            </div>
          </div>
          <div className="timetable--result">
            {timeTableDate &&
              timeTableDate.map((el, index) => (
                <div key={index} className="timetable--result-row">
                  <div className="result--cols " style={{ width: "18%" }}>
                    {el.fromcityname}
                  </div>
                  <div className="result--cols " style={{ width: "18%" }}>
                    {el.tocityname}
                  </div>
                  <div className="result--cols " style={{ width: "19%" }}>
                    {el.ServiceTypeName}
                  </div>
                  <div className="result--cols " style={{ width: "19%" }}>
                    {el.ViaPlaces}
                  </div>
                  <div className="result--cols " style={{ width: "15%" }}>
                    {el.ServiceNo}
                  </div>
                  <div className="result--cols " style={{ width: "11%" }}>
                    {el.ScheduleStart} - {el.ScheduleEnd}
                  </div>
                </div>
              ))}
            {!timeTableDate && (
              <div key="time-table-no-record" className="timetable--result-row">
                <div
                  className="result--cols"
                  style={{ textAlign: "center", color: "#f00" }}
                >
                  {t(TIME_TABLE_NOT_PRESENT)}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Result;
